<div class="login-container" ng-controller="SignInCtrl">
  <div class="bubbles">
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
  </div>

  <div class="left-section">
    <div class="main-logo">
      <img src="assets/images/cliQTest Logo Full.png" alt="CliQTest Logo">
    </div>
    <div class="subtitle">
      Start your<br>
      scriptless<br>
      automation<br>
      journey with<br>
      us
    </div>
  </div>

  <div class="login-wrapper">
    <div class="login-box">
      <div class="login-header">
        <div class="brand-info">
          <h1 class="brand-name">Protean</h1>
          <p class="brand-tagline">Making usability better</p>
          <div class="login-mode-toggle">
          </div>
        </div>
      </div>


      <div class="form-container" name="signin">
        <!-- Enhanced Error Display with Close Button -->
        @if (isError) {
          <div class="alert alert-danger">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{errorMessage}}</span>
          </div>
        }

        <!-- commented for axis -->
        <div class="form-group">
          <div class="input-wrapper">
            <i class="fa fa-user input-icon"></i>
            <input class="form-control" name="username" [(ngModel)]="userObj.email" type="text" placeholder="Email"
              autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="section-login username" />
          </div>
        </div>

        <!-- commented for axis -->
        <div class="form-group">
          <div class="input-wrapper">
            <i class="fa fa-lock input-icon"></i>
            <input class="form-control" [(ngModel)]="userObj.password" name="password"
              [type]="showPassword ? 'text' : 'password'" placeholder="Enter your password" autocorrect="off"
              (keyup.enter)="onLogin()" autocapitalize="off" spellcheck="false"
              autocomplete="section-login current-password" />
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
              <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
              [title]="showPassword ? 'Hide Password' : 'Show Password'"></i>
            </button>
          </div>
        </div>

        <!-- commented for axis -->
        <button type="submit" class="btn btn-primary login-btn" (click)="onLogin()">
          Sign in now <i class="fa fa-arrow-right"></i>
        </button>

        <button type="button" class="btn btn-gradient saml-btn" (click)="onSamlLogin()">
          <i class="fa fa-shield"></i>
          <span>Login with SAML SSO</span>
          <i class="fa fa-arrow-right btn-arrow"></i>
        </button>


        <div class="additional-options">
          <button type="button" class="support-btn" (click)="mailToProteanSupport()">
            <i class="fa fa-envelope"></i> Contact Support
          </button>
          <button type="button" class="forgot-btn" (click)="forgotPassword()">
            <i class="fa fa-unlock-alt"></i> Forgot Password
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{msg}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>
    </div>
  </div>
</ng-template>

<ng-template #updatePassword let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Update Your Password</h5>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="PopoldPassword">Current Password</label>
        <div class="input-wrapper">
          <i class="fa fa-lock input-icon"></i>
          <input type="password" class="form-control" id="PopoldPassword" [(ngModel)]="PopoldPassword"
            name="PopoldPassword" />
        </div>
      </div>

      <div class="form-group">
        <label for="PopnewPassword">New Password</label>
        <div class="input-wrapper">
          <i class="fa fa-key input-icon"></i>
          <input type="password" class="form-control" id="PopnewPassword" [(ngModel)]="PopnewPassword"
            name="PopnewPassword" />
        </div>
      </div>

      <div class="form-group">
        <label for="PopconfirmPassword">Confirm Password</label>
        <div class="input-wrapper">
          <i class="fa fa-check input-icon"></i>
          <input type="password" class="form-control" id="PopconfirmPassword" [(ngModel)]="PopconfirmPassword"
            name="PopconfirmPassword" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="SaveChnage()">Save Changes</button>
  </div>
</ng-template>